/**
 * Derives the Lead API lot attributes (LotNumber, LotSize, LotType, LotFacing) from a lot object,
 * for leads originated from the Native Interactive Site Map (NHS20-8974).
 *
 * @module nativeInteractiveSiteMap/services/leadLotAttributesService
 */

/**
 * @param {Object} lot - The currently selected lot (see redux/dataSlice.js's lots[] shape).
 * @returns {{ lotNumber: string|null, lotSize: string|null, lotType: string|null, lotFacing: string|null }}
 */
function getLeadLotAttributes(lot) {
  const lotNumberPart = lot?.displayLabel ? `Lot ${lot.displayLabel}` : '';
  const groupPart = lot?.lotGroupName ? `Group ${lot.lotGroupName}` : '';
  const lotNumber = [lotNumberPart, groupPart].filter(Boolean).join(' ') || null;

  return {
    lotNumber,
    lotSize: lot?.formattedLotSize ?? null,
    lotType: (lot?.lotType && lot.lotType !== 'None') ? lot.lotType : null,
    lotFacing: (lot?.lotFacing && lot.lotFacing !== 'N/A') ? lot.lotFacing : null,
  };
}

export default getLeadLotAttributes;
